module.exports = __webpack_public_path__ + "static/media/database-storage.832bcfaf.svg";